/*
 * COPYRIGHT: EUMETSAT 2018
 * LICENSE: PROPRIETARY
 * PROJECT: WMS
 * 
 * All information contained herein is, and remains the property of EUMETSAT.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * EUMETSAT.
 */

import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {


    constructor(public confirmDialogService: ConfirmDialogService) {

    }

    confirm() {
        this.confirmDialogService.confirm();
    }

    cancel() {
        this.confirmDialogService.close();
    }

}



// WEBPACK FOOTER //
// ./src/layout/configrm-dialog/confirn-dialog.component.ts